import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-slate-100 px-4 py-6 md:px-12 md:py-8" data-id="element-87" data-mp="4uqfz2u0sewh">
      <div className="flex gap-3 rounded-md border border-amber-400 bg-white p-3.5 md:p-5" data-id="element-88" data-mp="4x327s6t9bfc">
        <ShieldCheckIcon className="h-9 w-9 shrink-0 text-amber-500" strokeWidth={1.75} aria-hidden data-id="element-89" data-mp="9wphs8a433rb" />
        <div data-id="element-90" data-mp="er365qqcwamh">
          <h2 className="text-[17px] font-extrabold uppercase leading-[1.15] tracking-[-0.2px] text-blue-950 md:text-[21px]" data-id="element-91" data-mp="jsiubrntyx93">
            Your purchase is protected
          </h2>
          <p className="mt-0.5 text-[12px] font-extrabold uppercase text-teal-700 md:text-[13px]" data-id="element-92" data-mp="nrrjskbu88yu">
            7-day money-back guarantee
          </p>
          <div className="mt-1.5 space-y-1 text-[14px] leading-[1.4] text-slate-600 md:text-[15px]" data-id="element-93" data-mp="xivx7flv7lrk">
            <p data-id="element-94" data-mp="12k35rgvu0oza">
              Explore all seven volumes and five bonuses. If they don't meet your expectations, request a refund within
              seven days, subject to the store's refund policy.
            </p>
          </div>
          <p className="mt-2 text-[12px] font-extrabold uppercase leading-tight text-amber-700 md:text-[13px]" data-id="element-95" data-mp="25t8a4fbs7nme">
            Explore your new professional resources with confidence.
          </p>
        </div>
      </div>
    </section>;
}